import { CheckCircleSolid, Times } from '@assets/svgs';
import { IconButton } from '@components/iconButton';
import { Box, SnackbarProps, Typography, SnackbarContent } from '@mui/material';
import { SnackbarKey, useSnackbar } from 'notistack';
import React, { ReactNode, useCallback } from 'react';
import { styled } from '@mui/material/styles';
import { ToastBaseProps } from './Toast';

export type ToastProps = SnackbarProps &
  ToastBaseProps & {
    actionFunction?: (id: SnackbarKey) => void;
    noAutoHide?: boolean;
    link?: ReactNode;
  };

// TODO palette

const StyledSnackbar = styled(SnackbarContent, {
  name: 'LinkToast',
  slot: 'Root',
})<SnackbarProps>(({ theme }) => ({
  borderRadius: theme.shape.borderRadius * 2,
  backgroundColor: theme.palette.primary.dark,
  borderLeft: `6px solid ${theme.palette.success.main}`,
  justifyContent: 'space-between',
  width: '400px',
  minHeight: '56px',
  flexWrap: 'nowrap',
  '.MuiSnackbarContent-message': {
    color: 'common.white',
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  '& .MuiSnackbarContent-action .MuiButton-root': {
    color: 'white',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  '.link': {
    borderColor: theme.palette.success.main,
    color: theme.palette.success.main,
  },
}));

export const LinkToast = React.forwardRef<HTMLDivElement, ToastProps>(({ link, message, variant, id }, ref) => {
  const { closeSnackbar } = useSnackbar();

  const handleDismiss = useCallback(() => {
    closeSnackbar(id);
  }, [id, closeSnackbar]);

  const action = (
    <IconButton variant='circularDark' size='small' onClick={handleDismiss}>
      <Times width='10px' height='10px' />
    </IconButton>
  );
  return (
    <StyledSnackbar
      ref={ref}
      action={action}
      message={
        <Box style={{ display: 'flex', alignContent: 'center', justifyContent: 'space-between', width: '100%' }}>
          <Box sx={{ display: 'flex' }}>
            <IconButton
              sx={{ margin: '0 8px 0 8px', cursor: 'auto', height: 'auto', svg: { fill: 'success.main' } }}
              className={variant}
              disableRipple
            >
              <CheckCircleSolid />
            </IconButton>
            <Box style={{ height: '36px', display: 'flex', alignItems: 'center' }}>
              <Typography variant='bodySmall' fontWeight='bold' color='common.white'>
                {message}
              </Typography>
            </Box>
          </Box>
          <Box style={{ height: '36px', display: 'flex', alignItems: 'center' }}>{link}</Box>
        </Box>
      }
    />
  );
});

LinkToast.displayName = 'LinkToast';
